﻿'use client';

import { RESTError } from "../API/RESTError";
import { forgottenPassword, forgottenPassword2Step1, forgottenPassword2Step2, register, UserTokenValidity, verifyUserToken } from "../API/Users/Users";
import { MainSite } from "../MainSite";
import { ILoginHashData } from "./ILoginHashData";
import { LoginHashDataManager } from "./LoginHashDataManager";

// interface JQuery {
//     bootstrapBtn(): JQuery;
//     bootstrapBtn(command: string): JQuery;
// }

export class LoginPage {

    private mainContainer: JQuery = null;
    private splashContainer: JQuery = null;
    private loginRegisterContainer: JQuery = null;
    private inputandButtonContainer: JQuery = null;
    private emailContainer: JQuery = null;
    private emailLoginInput: JQuery = null;
    private passwordLoginInput: JQuery = null;
    private emailInput: JQuery = null;
    private password1Container: JQuery = null;
    private password1Input: JQuery = null;
    private password2Container: JQuery = null;
    private password2Input: JQuery = null;
    private submitButton: JQuery = null;
    private inputValidation: boolean;
    private validationContainer: JQuery = null;
    private errorContainer: JQuery = null;
    private loginButton: JQuery;
    private loginHashDataManager: LoginHashDataManager = new LoginHashDataManager();
    private loginHashData: ILoginHashData;
    private hiddenInputToken: JQuery = null;

    private hash: string;

    public render(): void {
        //for small viewports, we want a responsive log in page. But not the rest of the site (see cleanup)
        document.getElementById("viewport").setAttribute("content", "width = device-width");
        this.hash = window.location.hash;

        if (window.location.hash == '' && location.protocol !== 'https:' && (window.location.port !== '51729' && window.location.port !== '51730')) {
            console.info('Redirecting to HTTPS connection to ensure cookies work properly.');
            location.replace(`https:${location.href.substring(location.protocol.length)}`);
            return;
        }

        $('body').empty();
        
        this.mainContainer = $('<div></div>').appendTo('body');
        //splash on left hand side
        this.splashContainer = $('<div class="midi_LoginPage_splashContainer"></div>').appendTo(this.mainContainer);

        //yellow box on top of splash
        var infoContainer = $('<div class="midi_LoginPage_splashContainer_infoBox"></div>').appendTo(this.splashContainer);
        //$('<h2 class="midi_common_shell-font"></h2>').appendTo(infoContainer).text("About");
        $('<div></div>').appendTo(infoContainer)
            .append($('<p class="midi_LoginPage_splashContainer_infoBox_header"></p>').text(branding.loginWelcomeText))
            .append($('<p></p>').text("Users with an @shell.com email address can create an account now to get full access to this site."));

        //right hand pannel
        this.loginRegisterContainer = $('<div class="midi_LoginPage_loginRegisterContainer"></div>').appendTo(this.mainContainer);
        var titleContainer = $('<div class="midi_LoginPage_pageTitleContainer"></div>').appendTo(this.loginRegisterContainer);
        $('<img class= "midi_LoginPage_shell" src = "/images/shell.png" />').appendTo(titleContainer);
        $('<h1 class="midi_LoginPage_pageTitle"></h1>').appendTo(titleContainer).text(branding.siteName);
        
        
        //content of right hand side pannel ( within inputandButtonContainer)
        this.inputandButtonContainer = $('<div class= "midi_LoginPage_inputandButtonContainer" > </div>').appendTo(this.loginRegisterContainer);
        this.hashChange();

        $(window).on('hashchange',() => {
            this.hashChange();
        });
    }

    private checkLoginInputs(): void { //TODO: possibly check email address actually exists
        this.inputValidation = true;
        if (!this.emailLoginInput.val() || !this.passwordLoginInput.val()) {
            var error = "Please complete all fields.";
            this.setError(error);
            this.inputValidation = false;
        }
        else {
            this.setError(null);
        }
        if (!this.emailLoginInput.val()) {
            this.emailLoginInput.addClass("midi_common_validation_warning");
        }
        else {
            this.emailLoginInput.removeClass("midi_common_validation_warning");
        }
        if (!this.passwordLoginInput.val()) {
            this.passwordLoginInput.addClass("midi_common_validation_warning");
        }
        else {
            this.passwordLoginInput.removeClass("midi_common_validation_warning");
        }

        if (!this.inputValidation) {
            return;
        }

        if (this.emailLoginInput.val() && this.passwordLoginInput.val()) {
            this.inputValidation = true;
        }
    }

    private renderLoginPage(userEmail?: string) {
        this.inputandButtonContainer.empty();

        var topContainer = $('<div class= "midi_LoginPage_inputandButtonContainer_top"> </div>').appendTo(this.inputandButtonContainer);

        if (branding.siteName == "METNET Global") {
            $('<div class="midi_LoginPage_alert alert alert-info"><i class="fa fa-info-circle fa-3x pull-left"></i><strong>Coming from METNET 4G?</strong> Click Create an account below. Your email address should be pre-approved to register immediately.</div>').appendTo(topContainer);
        }

        $('<span class="midi_LoginPage_inputandButtonContainer_top_title">Log in</span>').appendTo(topContainer);

        var createAccount = $('<div class="midi_LoginPage_rightHandLink"></div>').appendTo(topContainer);
        $('<a class= "midi_LoginPage_link" href="#LoginPage=Register">Create an account </a>').appendTo(createAccount);

        if (userEmail) {
            $('<div class="midi_LoginPage_alert alert alert-success"><i class="fa fa-check-circle fa-3x pull-left"></i><strong>Your account is now active!</strong><p>Please log in using your password.</p></div>').appendTo(this.inputandButtonContainer);
        }

        var emailLoginContainer = $('<div class="input-group"></div>').appendTo(this.inputandButtonContainer);
        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-envelope-o fa-fw"></i></span>').appendTo(emailLoginContainer);
        this.emailLoginInput = $('<input type="text" class="form-control"aria-describedby="basic-addon1" placeholder="Email address">').appendTo(emailLoginContainer);

        if (userEmail) {
            this.emailLoginInput.val(userEmail);
        }

        var passwordLoginContainer = $('<div class="input-group midi_LoginPage_topMargin"></div>').appendTo(this.inputandButtonContainer);
        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-key fa-fw"></i></span>').appendTo(passwordLoginContainer);
        this.passwordLoginInput = $('<input id="midi_LoginPage_login_password"type="password" class="form-control" aria-describedby="basic-addon1" placeholder="Password">').appendTo(passwordLoginContainer);

        var bottomContainer = $('<div class= "midi_LoginPage_topMargin"> </div>').appendTo(this.inputandButtonContainer);

        this.loginButton = $('<button type="button" class="btn btn-success midi_LoginPage_button">Log in</button>')
            .appendTo(bottomContainer)
            .click(() => {
            if (this.errorContainer) {
                this.errorContainer.remove();
            }
            this.checkLoginInputs();
            if (this.inputValidation) {
                MainSite.instance.tryLogin(this.emailLoginInput.val(), this.passwordLoginInput.val());
            }
        });

        this.passwordLoginInput.keypress((e) => {
            if (e.which == 13) {
                this.loginButton.click();
                return false;
            }
        });

        $('<a class="midi_LoginPage_link" id="midi_LoginPage_forgotPassword" href="#LoginPage=ForgottenPassword">Forgotten your password?</a>').appendTo(bottomContainer);
        this.validationContainer = $('<div id="midi_LoginPage_login_input_validation_container"></div>').appendTo(this.loginRegisterContainer);
    }

    public renderRegisterPage(userEmail?:string): void {
        this.inputandButtonContainer.empty();

        var topContainer = $('<div class= "midi_LoginPage_inputandButtonContainer_top"> </div>').appendTo(this.inputandButtonContainer);

        if (userEmail) {
            $('<span class="midi_LoginPage_inputandButtonContainer_top_title">Complete Registration</span>').appendTo(topContainer);
        }
        else {
            $('<span class="midi_LoginPage_inputandButtonContainer_top_title">Register</span>').appendTo(topContainer);
        }

        var createAccount = $('<div class="midi_LoginPage_rightHandLink"></div>').appendTo(topContainer);

        $('<a class="midi_LoginPage_link" href="#LoginPage=Login">Return to log in </a>').appendTo(createAccount);

        if (userEmail) {
            $('<div class="midi_LoginPage_alert alert alert-info"><i class="fa fa-info-circle fa-3x pull-left"></i>Your account has been pre-approved. Please choose a password for access to ' + branding.siteName + '.</div>').appendTo(topContainer);
        }
        else {
            var regionalAdminLink = MainSite.instance.setupRegionalAdminPopover($('<strong>Regional Administrator</strong>').css("cursor", "pointer"));
            $('<div class="midi_LoginPage_alert alert alert-info"><i class="fa fa-info-circle fa-3x pull-left"></i><p><strong>Have an @shell.com email address or an old METNET 4G account?</strong> If so then you can register instantly for access to ' + branding.siteName + '.</p><span><strong>Other users:</strong> please contact your </span>')
                .append(regionalAdminLink)
                .append(' to register.</div>')
                .appendTo(topContainer);
        }

        this.emailContainer = $('<div class="input-group" id="midi_LoginPage_registration_email_container"></div>').appendTo(this.inputandButtonContainer)
        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-envelope-o fa-fw"></i></span>').appendTo(this.emailContainer);
        this.emailInput = $('<input id="midi_LoginPage_registration_email_address" type="text" class="form-control" aria-describedby="basic-addon1" placeholder="Email address">').appendTo(this.emailContainer);
        if (userEmail) {
            this.emailInput.val(userEmail);
        }

        this.password1Container = $('<div class="input-group midi_LoginPage_topMargin"></div>').appendTo(this.inputandButtonContainer);
        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-key fa-fw"></i></span>').appendTo(this.password1Container);
        this.password1Input = $('<input id="midi_LoginPage_registration_password_1" type="password" class="form-control" aria-describedby="basic-addon1" placeholder="Password">').appendTo(this.password1Container);

        this.password2Container = $('<div class="input-group midi_LoginPage_topMargin"></div>').appendTo(this.inputandButtonContainer);
        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-key fa-fw"></i></span>').appendTo(this.password2Container);
        this.password2Input = $('<input id="midi_LoginPage_registration_password_2" type="password" class="form-control" aria-describedby="basic-addon1" placeholder="Confirm Password">').appendTo(this.password2Container);

        var bottomContainer = $('<div class= "midi_LoginPage_topMargin"> </div>').appendTo(this.inputandButtonContainer);

        var submitButton = $('<button type="button" class="btn btn-success midi_LoginPage_button">Register</button>')
            .appendTo(bottomContainer)
            .click(() => {
            this.checkRegistrationInputs();
                if (this.inputValidation) {
                    this.tryRegister(this.emailInput.val(), this.password1Input.val(), this.password2Input.val());
                }
            });

        this.password2Container.keypress((e) => {
            if (e.which == 13) {
                submitButton.click();
                return false;
            }
        });

    }

    private checkRegistrationInputs(): void { //TODO: possibly check email address actually exists
        this.inputValidation = true;
        if (!this.emailInput.val() || !this.password1Input.val() || !this.password2Input.val()) {
            var error = "Please complete all fields.";
            this.setError(error);
            this.inputValidation = false;
        }
        else {
            this.setError(null);
        }
        if (this.password1Input.val() != this.password2Input.val()) {
            this.password1Input.remove();
            this.password1Input = $('<input id="midi_LoginPage_registration_password_1" type="password" class="form-control" aria-describedby="basic-addon1">').appendTo(this.password1Container);

            this.password2Input.remove();
            this.password2Input = $('<input id="midi_LoginPage_registration_password_2" type="password" class="form-control" aria-describedby="basic-addon1">').appendTo(this.password2Container);

            var error = "Passwords do not match.";
            this.setError(error);
            this.inputValidation = false;
        }
        if (!this.emailInput.val()) {
            this.emailInput.addClass("midi_common_validation_warning");
        }
        else {
            this.emailInput.removeClass("midi_common_validation_warning");
        }
        if (!this.password1Input.val()) {
            this.password1Input.addClass("midi_common_validation_warning");
        }
        else {
            this.password1Input.removeClass("midi_common_validation_warning");
        }
        if (!this.password2Input.val()) {
            this.password2Input.addClass("midi_common_validation_warning");
        }
        else {
            this.password2Input.removeClass("midi_common_validation_warning");
        }

        if (!this.inputValidation) {
            return;
        }

        if (this.emailInput.val() && this.password1Input.val() && this.password2Input.val()) {
            this.inputValidation = true;
        }
    }

    private tryRegister(email: string, password1: string, password2: string): void {

        var shellEmailBool = false;
        if (email.length > 10) {
            if (email.slice(email.length - 10, email.length) == "@shell.com") {
                //need to check whether user has been pre-approved
                shellEmailBool = true;
            }
        }
        register(email, password1, shellEmailBool,(err: RESTError) => { // register user or if error then render the page again or try again
            if (this.errorContainer) {
                this.errorContainer.remove();
            }
            if (err) {
                // there has been an error registering
                this.setError(err.Message);
                //this.inputValidationWarning = $('<div id="midi_LoginPage_registration_error">Registration unsuccessful: ' + err.Message + '</div>').appendTo(this.validationContainer);
                //this.renderRegisterPage();
            } else {
                // registration has worked
                this.inputandButtonContainer.empty();
                //this.container = $('<div class="midi_LoginPage_main_container"></div>').appendTo('body');
                $('<div class="midi_LoginPage_alert alert alert-success"><i class="fa fa-check-circle fa-3x pull-left"></i><strong>Registration complete.</strong><p>A confirmation email will be sent shortly. Please click the link in the email to verify your email address and complete the registration process.</div>').appendTo(this.inputandButtonContainer);                    
                $('<a class="midi_LoginPage_link" href="#LoginPage=Login">Return to log in</a>').appendTo(this.inputandButtonContainer);
            }
        });
    }

    public renderPasswordResetPage(): void {
        this.inputandButtonContainer.empty();

        var topContainer = $('<div class= "midi_LoginPage_inputandButtonContainer_top"> </div>').appendTo(this.inputandButtonContainer);

        $('<span class="midi_LoginPage_inputandButtonContainer_top_title">Reset Password</span>').appendTo(topContainer);

        var createAccount = $('<div class="midi_LoginPage_rightHandLink"></div>').appendTo(topContainer);
        $('<a class="midi_LoginPage_link" href="#LoginPage=Login">Return to log in </a>').appendTo(createAccount);

        $('<div class="midi_LoginPage_alert panel panel-default"><div class="panel-body">Please enter your email address to <strong>reset your password</strong>. You will then be sent a new password by email.</div></div>').appendTo(topContainer);
        this.emailContainer = $('<div class="input-group" id="midi_LoginPage_registration_email_container"></div>').appendTo(this.inputandButtonContainer);
        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-envelope-o fa-fw"></i></span>').appendTo(this.emailContainer);
        this.emailInput = $('<input type="text" class="form-control" aria-describedby="basic-addon1" placeholder="Email address">').appendTo(this.emailContainer);

        var bottomContainer = $('<div class= "midi_LoginPage_topMargin"> </div>').appendTo(this.inputandButtonContainer);

        var resetPasswordButton = $('<button type="button" class="btn btn-success midi_LoginPage_button">Reset Password</button>')
            .appendTo(bottomContainer)
            .click(() => {
                if (!this.emailInput.val()) {
                    var error = "Please enter an email address.";
                    this.setError(error);
                    this.emailInput.addClass("midi_common_validation_warning");
                    return;
                } else {
                    this.emailInput.removeClass("midi_common_validation_warning");
                }
                this.tryForgottenPasswordReset(this.emailInput.val());
            });

        this.emailInput.keypress((e) => {
            if (e.which == 13) {
                resetPasswordButton.click();
                return false;
            }
        });

    }


    public renderPasswordResetPage2Step1(): void {
        this.inputandButtonContainer.empty();

        var topContainer = $('<div class= "midi_LoginPage_inputandButtonContainer_top"> </div>').appendTo(this.inputandButtonContainer);

        $('<span class="midi_LoginPage_inputandButtonContainer_top_title">Reset Password (step 1)</span>').appendTo(topContainer);

        var createAccount = $('<div class="midi_LoginPage_rightHandLink"></div>').appendTo(topContainer);
        $('<a class="midi_LoginPage_link" href="#LoginPage=Login">Return to log in </a>').appendTo(createAccount);

        $('<div class="midi_LoginPage_alert panel panel-default"><div class="panel-body">Please enter your email address to <strong>reset your password</strong>. You will then be sent a link that will allow you to set a new password.</div></div>').appendTo(topContainer);
        this.emailContainer = $('<div class="input-group" id="midi_LoginPage_registration_email_container"></div>').appendTo(this.inputandButtonContainer);
        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-envelope-o fa-fw"></i></span>').appendTo(this.emailContainer);
        this.emailInput = $('<input type="text" class="form-control" aria-describedby="basic-addon1" placeholder="Email address">').appendTo(this.emailContainer);

        var bottomContainer = $('<div class= "midi_LoginPage_topMargin"> </div>').appendTo(this.inputandButtonContainer);

        this.submitButton = $('<button type="button" class="btn btn-success midi_LoginPage_button">Send me a password reset link</button>')
            .appendTo(bottomContainer)
            .click(() => {
                if (!this.emailInput.val()) {
                    var error = "Please enter an email address.";
                    this.setError(error);
                    this.emailInput.addClass("midi_common_validation_warning");
                    return;
                } else {
                    this.emailInput.removeClass("midi_common_validation_warning");

                    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //: thanks to: https://stackoverflow.com/a/46181
                    if (!re.test(this.emailInput.val())) {
                        var error = "Please enter a valid email address.";
                        this.setError(error);
                        this.emailInput.addClass("midi_common_validation_warning");
                        return;
                    }
                }
                this.tryForgottenPasswordReset2Step1(this.emailInput.val());
            });

        this.emailInput.keypress((e) => {
            if (e.which == 13) {
                this.submitButton.click();
                return false;
            }
        });
    }


    public renderPasswordResetPage2Step2(userToken?: string): void {
        this.inputandButtonContainer.empty();

        var topContainer = $('<div class= "midi_LoginPage_inputandButtonContainer_top"> </div>').appendTo(this.inputandButtonContainer);

        $('<span class="midi_LoginPage_inputandButtonContainer_top_title">Reset Password (step 2)</span>').appendTo(topContainer);
        $('<div class="midi_LoginPage_rightHandLink"><a class="midi_LoginPage_link" href="#LoginPage=Login">Return to log in </a></div>').appendTo(topContainer);

        var loadingContainer = $('<div class="midi_LoginPage_alert alert alert-warning"><i class="fa fa-refresh fa-spin"></i> Checking the validity of the token...</div>').appendTo(this.inputandButtonContainer);

        this.hiddenInputToken = $('<input type="hidden" name="Token">').appendTo(this.inputandButtonContainer);

        if (userToken) {
            this.hiddenInputToken.val(userToken);
        }


        verifyUserToken(userToken, 10, (err: RESTError, data?: UserTokenValidity) => {
            if (err) {
                this.setError(err.Message);
                loadingContainer.remove();
            } else {
                loadingContainer.remove();

                this.emailContainer = $('<div class="input-group" id="midi_LoginPage_registration_email_container"></div>').appendTo(this.inputandButtonContainer)
                $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-envelope-o fa-fw"></i></span>').appendTo(this.emailContainer);
                this.emailInput = $('<input id="midi_LoginPage_registration_email_address" type="text" class="form-control" aria-describedby="basic-addon1" placeholder="Email address">').appendTo(this.emailContainer);
                this.emailInput.prop("readonly", true);
                if (data.UserAccountId) {
                    this.emailInput.val(data.UserAccountId);
                }

                this.password1Container = $('<div class="input-group midi_LoginPage_topMargin"></div>').appendTo(this.inputandButtonContainer);
                $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-key fa-fw"></i></span>').appendTo(this.password1Container);
                this.password1Input = $('<input id="midi_LoginPage_registration_password_1" type="password" class="form-control" aria-describedby="basic-addon1" placeholder="New Password">').appendTo(this.password1Container);

                this.password2Container = $('<div class="input-group midi_LoginPage_topMargin"></div>').appendTo(this.inputandButtonContainer);
                $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-key fa-fw"></i></span>').appendTo(this.password2Container);
                this.password2Input = $('<input id="midi_LoginPage_registration_password_2" type="password" class="form-control" aria-describedby="basic-addon1" placeholder="Confirm Password">').appendTo(this.password2Container);

                var bottomContainer = $('<div class= "midi_LoginPage_topMargin"> </div>').appendTo(this.inputandButtonContainer);

                this.submitButton = $('<button type="button" class="btn btn-success midi_LoginPage_button">Change my password</button>')
                    .appendTo(bottomContainer)
                    .click(() => {
                        this.checkRegistrationInputs();
                        if (this.inputValidation) {
                            this.tryForgottenPasswordReset2Step2(this.hiddenInputToken.val(), this.emailInput.val(), this.password2Input.val());
                        }
                    });

                this.password2Container.keypress((e) => {
                    if (e.which == 13) {
                        this.submitButton.click();
                        return false;
                    }
                });
            }
        });
    }



    private tryForgottenPasswordReset(email: string): void {
        if (this.errorContainer) {
            this.errorContainer.remove();
        }
        forgottenPassword(email,(err: RESTError) => { // register user or if error then render the page again or try again
            if (err) {
                // error registering
                this.setError(err.Message);
                //this.renderPasswordResetPage();
            } else {
                // registration has worked
                this.inputandButtonContainer.empty();
                $('<div class="midi_LoginPage_alert alert alert-success"><strong>Success!</strong> A new password has been sent to your email address. Please use this to log in and then change your password.</div>').appendTo(this.inputandButtonContainer);
                $('<a class="midi_LoginPage_link" href="#LoginPage=Login">Return to log in.</a>').appendTo(this.inputandButtonContainer);
            }
        });
    }


    private tryForgottenPasswordReset2Step1(email: string): void {
        if (this.errorContainer) {
            this.errorContainer.remove();
        }

        let btnHtml = this.submitButton.html();
        this.submitButton.html('<i class="fa fa-lg fa-fw fa-refresh fa-spin"></i> Sending a reset link via email...');
        this.submitButton.prop("disabled", true);

        forgottenPassword2Step1(email, (err: RESTError) => {
            if (err) {
                this.setError(err.Message);
                this.submitButton.html(btnHtml);
                this.submitButton.prop("disabled", false);
            } else {
                this.inputandButtonContainer.empty();
                $('<div class="midi_LoginPage_alert alert alert-success"><i class="fa fa-check"></i> A link has been sent to your email address. Follow this link to set your new password.</div>').appendTo(this.inputandButtonContainer);
                $('<a class="midi_LoginPage_link" href="#LoginPage=Login">Return to log in.</a>').appendTo(this.inputandButtonContainer);
            }
        });
    }

    private tryForgottenPasswordReset2Step2(token: string, email: string, password: string): void {
        if (this.errorContainer) {
            this.errorContainer.remove();
        }

        let btnHtml = this.submitButton.html();
        this.submitButton.html('<i class="fa fa-lg fa-fw fa-refresh fa-spin"></i> Changing your password...');
        this.submitButton.prop("disabled", true);

        forgottenPassword2Step2(token, email, password, (err: RESTError) => {
            if (err) {
                this.setError(err.Message);
                this.submitButton.html(btnHtml);
                this.submitButton.prop("disabled", false);
            } else {
                this.inputandButtonContainer.empty();
                $('<div class="midi_LoginPage_alert alert alert-success"><i class="fa fa-check"></i> <strong>Your password was changed.</strong><br>You may now log in with your <strong>new</strong> password.</div>').appendTo(this.inputandButtonContainer);
                $('<a class="midi_LoginPage_link" href="#LoginPage=Login">Return to log in.</a>').appendTo(this.inputandButtonContainer);
            }
        });
    }


    /**
     * Displays a login error, or hides the error if null is passed.
     */
    public setError(error: string) {
        if (this.errorContainer) {
            this.errorContainer.remove();
        }
        if (!error) {
            return;
        }
        if (typeof error !== 'undefined' && error !== 'No session cookie') {
            this.errorContainer = $('<div class="midi_LoginPage_alert alert alert-danger"><i class="fa fa-exclamation-triangle"></i> ' + error + '</div>').appendTo(this.inputandButtonContainer);
        }
    }

    /*
    * Specifies whether or not we are logging in in the background. In this case, the
    * user should not be able to click the login button a second time.
    */
    public setLoggingInInProgressState(loggingInInProgress: boolean) {
        if (this.loginButton) {
            if (loggingInInProgress) {
                // disable the button
                this.loginButton.prop('disabled', true);
                // show the loading spinner and text
                this.loginButton.html('<i class="fa fa-spinner fa-spin"></i> Logging in...');
            }
            else {
                // enable the button and 
                this.loginButton.prop('disabled', false);
                // show the original text
                this.loginButton.html('Log in');
            }
        }
    }
    
    private hashChange():void {
        this.loginHashData = this.loginHashDataManager.decode(window.location.hash);

        var userEmail = this.loginHashData.UserEmail;
        var loginPage = this.loginHashData.LoginPage;

        if (loginPage) {
            if (loginPage == "Register") {
                this.renderRegisterPage(userEmail);
            }
            else if (loginPage == "Login") {
                this.renderLoginPage(userEmail);
            }
            else if (loginPage == "ForgottenPassword-Old") {
                this.renderPasswordResetPage();
            }
            else if (loginPage == "ForgottenPassword") {
                this.renderPasswordResetPage2Step1();
            }
            else if (loginPage == "ResetPassword") {
                let userToken = this.loginHashData.Token;
                this.renderPasswordResetPage2Step2(userToken);
            }
            else {
                this.renderLoginPage();
            }
        }
        else {
            this.renderLoginPage();
        }
    }

    public cleanUp() {
        document.getElementById("viewport").setAttribute("content", "width = 1000px");
        $('body').empty();
        window.location.hash = this.hash;
        $(window).off('hashchange');
    }
}

